import { applyAuth0Theme } from "@/utils/theme/themeEngine";

import PasskeyEnrollmentForm from "./components/PasskeyEnrollmentForm";
import { usePasskeyEnrollmentManager } from "./hooks/usePasskeyEnrollmentManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function PasskeyEnrollmentScreen() {
    // Extracting attributes from hook made out of PasskeyEnrollmentInstance class of Auth0 React ACUL SDK
    const { texts, locales, passkeyEnrollmentInstance } =
        usePasskeyEnrollmentManager();

    // Apply theme from SDK instance when screen loads
    applyAuth0Theme(passkeyEnrollmentInstance);
    return (
        // Applying UDS theme overrides using the "theme-universal" class
        <AuthLayout title={texts?.pageTitle || locales.page.title}>

            <PasskeyEnrollmentForm />
            </AuthLayout>
    );
}

export default PasskeyEnrollmentScreen;
